import { PLAN_ASSESSED, STATS_UNLOADED } from './types.js'

export default function stats(state = {}, action = {}){
  switch (action.type) {
    case PLAN_ASSESSED:
      return action.data
    case STATS_UNLOADED:
      return {}
    default:
      return state
  }
}
